module.exports = __webpack_public_path__ + "images/header-menu-icons@2x-0ce4154e55b3834eb4d1fbd19687fe90.png";